var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "launch",
    class: _vm.isMobile && 'wap'
  }, [_c('p-head'), _c('div', {
    staticClass: "launch-main main"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "loading"
  }, [_c('svg-icon', {
    attrs: {
      "name": "loading",
      "spin": ""
    }
  })], 1), _vm._v(" " + _vm._s(_vm.$lang("Twitter Callback")) + " ")])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };